import React from "react"
import { StoreProvider } from "./src/store";

// eslint-disable-next-line react/display-name,react/prop-types,import/no-anonymous-default-export
export default ({ element }) => {
  return <StoreProvider>{element}</StoreProvider>
}
